/* ============================================================
   RagHouse Boutique — Sunroom storefront behavior
   Rail scrolling, wishlist (localStorage), PDP accordions, toast.
   Cart drawer + AJAX add-to-cart are layered in rh-cart.js.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  window.rhToast = function (msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'rh-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('rh-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('rh-show');
    }, 2200);
  };

  /* ---------- wishlist (client-side, localStorage) ---------- */
  var WKEY = 'rh_wishlist';
  function wishSet() {
    try {
      return new Set(JSON.parse(localStorage.getItem(WKEY) || '[]'));
    } catch (e) {
      return new Set();
    }
  }
  function wishSave(set) {
    try {
      localStorage.setItem(WKEY, JSON.stringify(Array.from(set)));
    } catch (e) {}
  }
  function paintWish() {
    var set = wishSet();
    document.querySelectorAll('[data-rh-wish]').forEach(function (b) {
      b.classList.toggle('rh-on', set.has(b.getAttribute('data-rh-wish')));
    });
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    // mobile hamburger nav toggle
    var navToggle = e.target.closest('[data-rh-nav-toggle]');
    if (navToggle) {
      var hdr = document.querySelector('[data-rh-header]');
      if (hdr) {
        var open = hdr.classList.toggle('rh-nav-open');
        navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }
    // close the mobile nav after tapping a nav link (let navigation proceed)
    var navLink = e.target.closest('.rh-mainnav a');
    if (navLink) {
      var openHdr = document.querySelector('[data-rh-header].rh-nav-open');
      if (openHdr) {
        openHdr.classList.remove('rh-nav-open');
        var tgl = openHdr.querySelector('[data-rh-nav-toggle]');
        if (tgl) tgl.setAttribute('aria-expanded', 'false');
      }
    }

    // PLP density (2/3/4)
    var colsBtn = e.target.closest('[data-rh-cols-set]');
    if (colsBtn) {
      var c = colsBtn.getAttribute('data-rh-cols-set');
      try {
        localStorage.setItem('rh_plp_cols', c);
        localStorage.setItem('rh_plp_view', 'grid');
      } catch (er) {}
      document.querySelectorAll('.rh-plp .rh-product-grid').forEach(function (g) {
        g.setAttribute('data-rh-cols', c);
        g.setAttribute('data-rh-view', 'grid');
      });
      syncViewButtons(c, 'grid');
      return;
    }
    // PLP grid/list
    var viewBtn = e.target.closest('[data-rh-view-set]');
    if (viewBtn) {
      var v = viewBtn.getAttribute('data-rh-view-set');
      try {
        localStorage.setItem('rh_plp_view', v);
      } catch (er2) {}
      document.querySelectorAll('.rh-plp .rh-product-grid').forEach(function (g) {
        g.setAttribute('data-rh-view', v);
      });
      syncViewButtons(null, v);
      return;
    }
    // PLP mobile filter drawer toggle (button + overlay + close all share the hook)
    var filterToggle = e.target.closest('[data-rh-filter-toggle]');
    if (filterToggle) {
      var plp = document.querySelector('[data-rh-plp]');
      if (plp) {
        var opened = plp.classList.toggle('rh-filters-open');
        var ft = plp.querySelector('.rh-plp-filter-toggle');
        if (ft) ft.setAttribute('aria-expanded', opened ? 'true' : 'false');
      }
      return;
    }

    // rail arrows
    var next = e.target.closest('[data-rh-rail-next]');
    if (next) {
      scrollRail(next.getAttribute('data-rh-rail-next'), 320);
      return;
    }
    var prev = e.target.closest('[data-rh-rail-prev]');
    if (prev) {
      scrollRail(prev.getAttribute('data-rh-rail-prev'), -320);
      return;
    }

    // wishlist toggle
    var wb = e.target.closest('[data-rh-wish]');
    if (wb) {
      e.preventDefault();
      var id = wb.getAttribute('data-rh-wish');
      var set = wishSet();
      if (set.has(id)) {
        set.delete(id);
      } else {
        set.add(id);
      }
      wishSave(set);
      paintWish();
      return;
    }

    // PDP accordion
    var head = e.target.closest('.rh-acc-head');
    if (head) {
      head.parentElement.classList.toggle('rh-open');
      return;
    }
  });

  function scrollRail(id, by) {
    var rail = document.getElementById(id);
    if (rail) rail.scrollBy({ left: by, behavior: 'smooth' });
  }

  /* ---------- PLP facet + sort auto-submit (one GET form) ---------- */
  document.addEventListener('change', function (e) {
    var ctrl = e.target.closest('[data-rh-auto-submit]');
    if (!ctrl) return;
    var form = ctrl.closest('[data-rh-plp-form]');
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
  });

  /* ---------- PLP view options (persisted density + grid/list) ---------- */
  function syncViewButtons(cols, view) {
    var grid = document.querySelector('.rh-plp .rh-product-grid');
    if (!cols) cols = grid && grid.getAttribute('data-rh-cols');
    if (!view) view = (grid && grid.getAttribute('data-rh-view')) || 'grid';
    document.querySelectorAll('[data-rh-cols-set]').forEach(function (b) {
      b.classList.toggle('rh-active', b.getAttribute('data-rh-cols-set') === cols);
    });
    document.querySelectorAll('[data-rh-view-set]').forEach(function (b) {
      b.classList.toggle('rh-active', b.getAttribute('data-rh-view-set') === view);
    });
  }
  function applyPlpView() {
    var grids = document.querySelectorAll('.rh-plp .rh-product-grid');
    if (!grids.length) return;
    var cols, view;
    try {
      cols = localStorage.getItem('rh_plp_cols');
      view = localStorage.getItem('rh_plp_view');
    } catch (e) {}
    grids.forEach(function (g) {
      if (cols) g.setAttribute('data-rh-cols', cols);
      if (view) g.setAttribute('data-rh-view', view);
    });
    syncViewButtons(cols, view);
  }

  document.addEventListener('DOMContentLoaded', function () {
    paintWish();
    applyPlpView();
  });
})();
